import { CallStatus } from '../../enums';
import { setCallStatus } from '../../util/error-handling/StatusByCallHelpers';

import { AMSState } from './index';
import { AMSCall } from './types';

export function setAMSCallStatus(call: AMSCall, status: CallStatus, state: AMSState, errorCode?: number) {
  setCallStatus(call, AMSCall[call], status, state.statusByCall, errorCode, state.errorsLog);
}
